<template>
  <Dialog :title="title" custom-class="dialogBg" width="1600px" top="8vh" :modal="true" :modal-append-to-body="false" :visible.sync="status">

    <div class="audio-wrap">
      <div class="vfWrap">
        <LyricManager :txts="content" v-if="status"/>
        <!-- <div v-text="content"></div> -->
      </div>
    </div>
  </Dialog>
</template>

<script>
import { Dialog } from "element-ui";
import LyricManager from 'business/LyricManager';

export default {
  components: {
    Dialog,
    LyricManager
  },
  data() {
    return {
      status: false,
      title: '',
      content: ''
    }
  },
  // mounted() {
  //   this.$post('/course/sectionInfo.json',{
  //     courseId: 3312,
  //   })
  // },
  methods: {
    openPreview(txt,title) {
      // if(typeof txt === 'number') {
      //   this.loadDetail(txt)
      // } else {
        this.content = txt;
        this.status = true;
      // }
      this.title = title + ' - 课件预览';
    },
    // async loadDetail(courseId) {
    //   const res = await this.$post('/course/info.json', {
    //     courseId
    //   })
    //   const {skills,article} = res.data || {};
    //   this.content = skills?.contents || article?.contents;
    //   this.status = true;
    // }
  }
}
</script>


<style lang="less" scoped>
.audio-wrap {
  overflow: hidden;
  width:1200px;
  margin: 0 auto;
  background: #FFFCF7;
  box-shadow: 0px 0px 10px 1px rgba(189, 94, 39, 0.05), inset 0px 0px 33px 10px rgba(255, 255, 255, 0.5);
  border-radius: 20px 20px 0px 0px;
  padding: 40px 110px;
  box-sizing: border-box;
  max-height: 80vh;
  min-height: 66vh;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: baseline;
}
</style>